import React from 'react'
import { type OracleCardDocument } from '../../graphql-types'
import { DivinationCardRenderer } from './DivinationCardRenderer'

// NOTE: sending the message "MONKEY_BUTT" from the chat input will force the
// backend to pull a card, even if you've pulled one already today. This is a
// workaround for client development when we need to pull cards repeatedly.

interface OracleCardRendererProps {
  oracle: OracleCardDocument
  createdAt?: string
}

export const OracleCardRenderer: React.FC<OracleCardRendererProps> = ({
  oracle,
  createdAt,
}) => (
  <DivinationCardRenderer
    objects={oracle.objects}
    pulledAt={createdAt || oracle.pulledAt || undefined}
    classPrefix="oracle-card-renderer"
  />
)
